import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Col, Row, Space, Typography } from 'antd'

import { useQueryParams } from '../../../core/hooks'
import { getFilterOptions } from '../../../core/utils'

import { PAGINATION } from '../../../common/constants'

import {
  DEFAULT_UNKNOWN_WORD_SORT_BY,
  UNKNOWN_WORDS_SORT_BY,
} from '../../constants'
import {
  StyledUnknownWordsSortByCol,
  StyledUnknownWordsSortBySelect,
  StyledUnknownWordsSortByText,
} from '../styled'

const UnknownWordsModalHeader = () => {
  const { data: menuCurationTask } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const {
    curatedUnknownWordCount,
    qadUnknownWordCount,
    totalUnknownWordCount,
  } = menuCurationTask

  const { sortUnknownWordsBy = DEFAULT_UNKNOWN_WORD_SORT_BY, setQueryParams } =
    useQueryParams()

  const sortByOptions = useMemo(
    () => getFilterOptions(UNKNOWN_WORDS_SORT_BY, 'label', 'value'),
    [],
  )

  const handleSortByChange = useCallback(
    sortByValue =>
      setQueryParams({
        sortUnknownWordsBy: sortByValue,
        brandSuggestedWordsCurrentPage: PAGINATION.DEFAULT_PAGE,
      }),
    [setQueryParams],
  )

  return (
    <Row type="flex" justify="space-between">
      <Col span={12}>
        <Space>
          <Typography.Text>
            <Space>
              Curated Unknown words
              {curatedUnknownWordCount} /{totalUnknownWordCount}
            </Space>
          </Typography.Text>
          <Typography.Text>
            <Space>
              Qad Unknown words
              {qadUnknownWordCount} /{totalUnknownWordCount}
            </Space>
          </Typography.Text>
        </Space>
      </Col>
      <StyledUnknownWordsSortByCol span={6}>
        <StyledUnknownWordsSortByText>
          Sort by:
          <StyledUnknownWordsSortBySelect
            size="small"
            showSearch
            value={sortUnknownWordsBy}
            onChange={handleSortByChange}
            options={sortByOptions}
          />
        </StyledUnknownWordsSortByText>
      </StyledUnknownWordsSortByCol>
    </Row>
  )
}

export default UnknownWordsModalHeader
